import ProcessFlowStep from "~/models/processFlows/processFlowStep";
import {SetDataVariableMap} from "~/models/processFlows/steps/setDataVariableMap";
import {Hash} from "~/interfaces/hashInterfaces";
import MappableStep from "~/models/processFlows/constructorMixins/mappableStep";
import {ISetDataStep} from '~/interfaces/processFlowInterfaces'
import {ProcessFlowStepType} from '../../../enums/processFlowStepType'

export class ProcessFlowSetDataStep extends MappableStep(ProcessFlowStep, SetDataVariableMap) implements ISetDataStep {
  step_type: ProcessFlowStepType.SetData

  initializeEmbedded(parent: ProcessFlowStep, item: SetDataVariableMap, json: Hash = {}, selectItem: boolean = true) {
    item.attachToParent(parent)
    return item;
  }

  get defaultTitle(): string {
    return `Set data`
  }

}